var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _g, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _g2, _path87, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRubixCompute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 589,
    height: 840,
    viewBox: "0 0 589 840",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_934_180)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M223.3 666.07V707.94L295.83 749.81L295.4 707.94L223.3 666.07Z",
    fill: "#6E9965",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M223.3 666.07L251.14 650.44L323.66 692.31L295.4 707.94L223.3 666.07Z",
    fill: "#6E9965",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M245.723 705.035C248.158 703.687 248.239 699.175 245.904 694.957C243.568 690.738 239.701 688.412 237.266 689.76C234.831 691.108 234.75 695.621 237.085 699.839C239.42 704.057 243.287 706.383 245.723 705.035Z",
    fill: "#43663A",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M263.683 715.711C266.118 714.363 266.199 709.85 263.864 705.632C261.529 701.414 257.661 699.088 255.226 700.436C252.791 701.784 252.71 706.296 255.045 710.515C257.381 714.733 261.248 717.059 263.683 715.711Z",
    fill: "#43663A",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M281.806 726.18C284.241 724.832 284.322 720.319 281.987 716.101C279.651 711.883 275.784 709.556 273.349 710.905C270.914 712.253 270.833 716.765 273.168 720.983C275.503 725.201 279.37 727.528 281.806 726.18Z",
    fill: "#43663A",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M475.5 400L403.5 443L385 545.5L400 769L431.5 822L466.5 811L480 757.5V665.5L488 545.5L475.5 400Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M295.51 707.939V749.809L368.03 791.679L367.6 749.809L295.51 707.939Z",
    fill: "#6E9965",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M295.51 707.94L323.34 692.31L395.86 734.19L367.6 749.81L295.51 707.94Z",
    fill: "#6E9965",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M317.918 746.915C320.353 745.567 320.434 741.055 318.099 736.836C315.764 732.618 311.896 730.292 309.461 731.64C307.026 732.988 306.945 737.501 309.28 741.719C311.615 745.937 315.483 748.263 317.918 746.915Z",
    fill: "#43663A",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M335.884 757.59C338.319 756.242 338.4 751.729 336.065 747.511C333.729 743.293 329.862 740.967 327.427 742.315C324.992 743.663 324.911 748.175 327.246 752.393C329.581 756.612 333.449 758.938 335.884 757.59Z",
    fill: "#43663A",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M354.02 768.055C356.456 766.707 356.537 762.194 354.201 757.976C351.866 753.758 347.999 751.431 345.564 752.78C343.128 754.128 343.047 758.64 345.383 762.858C347.718 767.076 351.585 769.403 354.02 768.055Z",
    fill: "#43663A",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M148.49 223.24L422.39 381.5L367.78 413.03L93.8799 254.77L148.49 223.24Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M148.77 97.4297L148.49 223.24L435.44 389.03L435.39 262.9L148.77 97.4297Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M105.15 260.12L152.98 232.5L164.79 239.63L116.96 267.25",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M122.41 270.85L170.24 243.23L182.05 250.36L134.22 277.97",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M140.36 280.95L188.19 253.34L200 260.46L152.17 288.08",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M158.57 291.68L206.41 264.06L218.22 271.19L170.38 298.81",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M177.21 301.49L225.04 273.88L236.85 281.01L189.02 308.62",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M194.47 312.22L242.3 284.61L254.11 291.74L206.28 319.35",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M212.42 322.33L260.25 294.71L272.07 301.84L224.23 329.46",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M230.64 333.06L278.47 305.44L290.28 312.57L242.45 340.19",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M250.23 343.88L298.07 316.26L309.88 323.39L262.04 351.01",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M267.49 354.61L315.32 326.99L327.13 334.12L279.3 361.74",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M285.45 364.71L333.28 337.1L345.09 344.23L297.26 371.84",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M303.66 375.44L351.49 347.83L363.3 354.96L315.47 382.57",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M322.3 385.26L370.13 357.64L381.94 364.77L334.11 392.39",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M339.55 395.99L387.39 368.37L399.2 375.5L351.36 403.11",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M444.71 729.53L444.5 725.35L443.02 704.55C438.49 616.88 438.34 532 442.86 444.35",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M444.71 729.53L444.5 725.35L443.02 704.55C438.49 616.88 438.34 532 442.86 444.35",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M448.819 357.16L450.859 334.32L367.779 286.9L367.669 411.52L93.6995 253.33V127.19L12.9495 80.5801L8.10949 154.62C1.61949 253.91 0.949489 353.49 6.09949 452.86L12.9495 585.12L93.6995 631.74V505.6L367.679 663.78V789.92L449.899 837.39L449.129 817.53",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M448.819 357.16L450.859 334.32L367.779 286.9L367.669 411.52L93.6995 253.33V127.19L12.9495 80.5801L8.10949 154.62C1.61949 253.91 0.949489 353.49 6.09949 452.86L12.9495 585.12L93.6995 631.74V505.6L367.679 663.78V789.92L449.899 837.39L449.129 817.53",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M366.73 727.91L147.45 601.52V538.53L366.73 665.13V727.91Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0596 82.09L149.31 2.5L586.25 254.77L450 334.36L367.78 286.89L422.52 255.43L148.77 97.43L93.7996 128.71L13.0596 82.09Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M449.13 816.29L449.89 836.15L586.25 758.08V253.54L450 333.13L448.9 357.38",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M449.13 816.29L449.89 836.15L586.25 758.08V253.54L450 333.13L448.9 357.38",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M443.09 443.9L441.58 477.52C439.11 531.86 438.58 584.9 440.56 639.26L444.5 722.65",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M443.09 443.9L441.58 477.52C439.11 531.86 438.58 584.9 440.56 639.26L444.5 722.65",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M447.85 793.36L448.09 798.46",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M446.63 767.58L446.98 775.09",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M445.47 743.17L445.79 749.81",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M444.82 421.02L444.55 426.99",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M445.88 397.66L445.61 403.68",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M447.25 374.5L446.979 380.4",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M121.15 18.37L558.6 270.93L559.24 773.39L586.25 757.6V254.77L149.31 2.5L121.15 18.37Z",
    fill: "#D7DCE0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1197 238.11L23.9097 274C21.3697 315.22 21.1997 356.55 23.4197 397.79L26.1297 448.27L422.53 678.92L420.44 642.09C417.61 592.15 417.79 542.08 421 492.16L422.53 468.33L26.1197 238.11Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M148.77 50.2803V97.4303L230.45 144.59L229.97 97.4303L148.77 50.2803Z",
    fill: "#FC6833",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M148.77 50.2799L180.12 32.6699L261.79 79.8299L229.97 97.4299L148.77 50.2799Z",
    fill: "#FC6833",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M261.79 79.8301V126.99L230.45 144.59L229.97 97.4301L261.79 79.8301Z",
    fill: "#FC6833",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M174.043 94.1529C176.788 92.6335 176.879 87.5475 174.247 82.793C171.614 78.0386 167.256 75.416 164.511 76.9354C161.767 78.4548 161.676 83.5408 164.308 88.2953C166.94 93.0498 171.299 95.6723 174.043 94.1529Z",
    fill: "#BC411B",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M194.274 106.17C197.018 104.651 197.109 99.5651 194.477 94.8106C191.845 90.0561 187.486 87.4336 184.742 88.953C181.997 90.4724 181.906 95.5584 184.538 100.313C187.171 105.067 191.529 107.69 194.274 106.17Z",
    fill: "#BC411B",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M214.699 117.964C217.444 116.445 217.535 111.359 214.902 106.605C212.27 101.85 207.911 99.2275 205.167 100.747C202.423 102.266 202.332 107.352 204.964 112.107C207.596 116.861 211.955 119.484 214.699 117.964Z",
    fill: "#BC411B",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M211.31 78.9701L229.3 68.5801L247.3 78.9701L229.3 89.3601L211.31 78.9701Z",
    fill: "#BC411B",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M186.529 65.2396L204.529 54.8496L222.519 65.2396L204.529 75.6296L186.529 65.2396Z",
    fill: "#BC411B",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M163.27 51.14L181.26 40.75L199.25 51.14L181.26 61.53L163.27 51.14Z",
    fill: "#BC411B",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M148.49 601.68L93.8798 633.22L93.7998 507.12L148.49 538.69V601.68Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M511.31 553.39V629.85L544.42 648.97V572.51L511.31 553.39Z",
    fill: "#6E9965",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M544.419 572.51V648.97L568.109 635.29V558.83L544.419 572.51Z",
    fill: "#6E9965",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M550.109 577.72V590.92C550.109 591.77 551.029 592.3 551.769 591.88L563.199 585.28C563.539 585.08 563.749 584.72 563.749 584.32V571.12C563.749 570.27 562.829 569.74 562.089 570.16L550.659 576.76C550.319 576.96 550.109 577.32 550.109 577.72Z",
    fill: "#43663A",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M550.109 601.46V614.66C550.109 615.51 551.029 616.04 551.769 615.62L563.199 609.02C563.539 608.82 563.749 608.46 563.749 608.06V594.86C563.749 594.01 562.829 593.48 562.089 593.9L550.659 600.5C550.319 600.7 550.109 601.06 550.109 601.46Z",
    fill: "#43663A",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M550.109 623.47V636.67C550.109 637.52 551.029 638.05 551.769 637.63L563.199 631.03C563.539 630.83 563.749 630.47 563.749 630.07V616.87C563.749 616.02 562.829 615.49 562.089 615.91L550.659 622.51C550.319 622.71 550.109 623.07 550.109 623.47Z",
    fill: "#43663A",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M516.43 567.81L539.3 581.02",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M516.43 577.31L539.3 590.52",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M516.43 588.38L539.3 601.59",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M516.43 597.88L539.3 611.09",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M516.43 608.39L539.3 621.6",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M516.43 617.89L539.3 631.1",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.96
  }, /*#__PURE__*/React.createElement("path", {
    d: "M511.31 477.52V553.98L544.42 573.1V496.64L511.31 477.52Z",
    fill: "#6E9965",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.31 477.52L535 463.84L568.11 482.96L544.42 496.64L511.31 477.52Z",
    fill: "#6E9965",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.419 496.64V573.1L568.109 559.42V482.96L544.419 496.64Z",
    fill: "#6E9965",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.109 501.85V515.05C550.109 515.9 551.029 516.43 551.769 516.01L563.199 509.41C563.539 509.21 563.749 508.85 563.749 508.45V495.25C563.749 494.4 562.829 493.87 562.089 494.29L550.659 500.89C550.319 501.09 550.109 501.45 550.109 501.85Z",
    fill: "#43663A",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.109 525.59V538.79C550.109 539.64 551.029 540.17 551.769 539.75L563.199 533.15C563.539 532.95 563.749 532.59 563.749 532.19V518.99C563.749 518.14 562.829 517.61 562.089 518.03L550.659 524.63C550.319 524.83 550.109 525.19 550.109 525.59Z",
    fill: "#43663A",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.109 547.61V560.81C550.109 561.66 551.029 562.19 551.769 561.77L563.199 555.17C563.539 554.97 563.749 554.61 563.749 554.21V541.01C563.749 540.16 562.829 539.63 562.089 540.05L550.659 546.65C550.319 546.85 550.109 547.21 550.109 547.61Z",
    fill: "#43663A",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.43 491.939L539.3 505.149",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.43 501.45L539.3 514.65",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.43 512.51L539.3 525.72",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.43 522.01L539.3 535.22",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.43 532.52L539.3 545.729",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.43 542.02L539.3 555.229",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M350.959 187.79L381.939 169.9L412.919 187.63L381.939 205.67L350.959 187.79Z",
    fill: "#B2B2B2",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M400.03 215.62L431.01 197.74L461.99 215.46L431.01 233.51L400.03 215.62Z",
    fill: "#B2B2B2",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M448.389 358.97L505.019 327.96V341.35L447.419 373.74L427.029 362.38C424.919 361.21 423.599 359 423.559 356.58C423.479 351.36 429.099 348.03 433.639 350.6L448.379 358.96L448.389 358.97Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M446.83 382.68L505.02 351.96V365.35L445.91 397.02L426.75 385.93C424.74 384.77 423.49 382.63 423.45 380.31C423.37 375.11 429.04 371.87 433.49 374.56L446.84 382.67L446.83 382.68Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M445.35 405.36L505.03 375.02V388.41L444.41 420.3L426.5 408.89C424.64 407.71 423.5 405.67 423.47 403.46C423.39 398.24 429.14 395.03 433.55 397.83L445.37 405.36H445.35Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M444.45 428.88L505.03 397.83V411.22L443.14 442.89L426.41 432.17C424.6 431.01 423.49 429.02 423.46 426.87C423.38 421.7 429.15 418.57 433.44 421.46L444.45 428.87V428.88Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M448.31 800.2L508.89 769.15V782.54L448.57 815.22L430.27 803.49C428.46 802.33 427.35 800.34 427.32 798.19C427.24 793.02 433.01 789.89 437.3 792.78L448.31 800.19V800.2Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M447.15 776.42L507.729 745.37V758.76L447.41 791.44L429.109 779.71C427.299 778.55 426.19 776.56 426.16 774.41C426.08 769.24 431.849 766.11 436.139 769L447.15 776.41V776.42Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M445.859 751.18L506.439 720.13V733.52L446.119 766.2L427.819 754.47C426.009 753.31 424.899 751.32 424.869 749.17C424.789 744 430.559 740.87 434.849 743.76L445.859 751.17V751.18Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M444.609 726.87L505.189 695.82V709.21L444.869 741.89L426.569 730.16C424.759 729 423.649 727.01 423.619 724.86C423.539 719.69 429.309 716.56 433.599 719.45L444.609 726.86V726.87Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8999 109.9L29.1599 120.04C31.0499 121.09 32.2299 123.06 32.2599 125.21C32.3299 129.87 27.2999 132.84 23.2299 130.54L9.85986 122.98",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54 132.62L27.8 142.76C29.69 143.81 30.87 145.78 30.9 147.93C30.97 152.59 25.94 155.56 21.87 153.26L8.5 145.7",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25973 154.841L26.5197 164.981C28.4097 166.031 29.5897 168.001 29.6197 170.151C29.6897 174.811 24.6597 177.781 20.5897 175.481L7.21973 167.921",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87984 177.07L25.1398 187.21C27.0298 188.26 28.2098 190.23 28.2398 192.38C28.3098 197.04 23.2798 200.01 19.2098 197.71L5.83984 190.15",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06982 482.96L26.3298 493.1C28.2198 494.15 29.3998 496.12 29.4298 498.27C29.4998 502.93 24.4698 505.9 20.3998 503.6L8.38982 496.81",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16992 506.11L27.4299 516.25C29.3199 517.3 30.4999 519.27 30.5299 521.42C30.5999 526.08 25.5699 529.05 21.4999 526.75L9.91992 520.2",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0298 528.79L28.2898 538.93C30.1798 539.98 31.3598 541.95 31.3898 544.1C31.4598 548.76 26.4298 551.73 22.3598 549.43L10.7798 542.88",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6499 551.86L29.2199 561.61C31.1099 562.66 32.2899 564.63 32.3199 566.78C32.3899 571.44 27.3599 574.41 23.2899 572.11L11.9699 565.71",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_934_180",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 410,
    width: 91,
    height: 77
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4995 434.73L41.5695 410.13L131.36 461.98L131.29 486.57L41.4995 434.73Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_934_180)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_934_180",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 410,
    width: 91,
    height: 77
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5695 410.13L131.36 461.98L131.29 486.57L41.4995 434.73L41.5695 410.13Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_934_180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.2598 436.02L74.4098 434.95V439.53C74.3998 440.12 74.4098 440.69 74.4098 441.23C74.4198 441.78 74.4297 442.31 74.4497 442.82C74.4697 443.33 74.4897 443.81 74.5197 444.28C74.5397 444.74 74.5797 445.17 74.6097 445.59C74.6097 445.71 74.6297 445.83 74.6397 445.95L67.6898 431.07L66.0297 430.11L65.9897 444.03L67.8398 445.1L67.8597 439.3C67.8597 439.18 67.8597 439.04 67.8497 438.87C67.8497 438.72 67.8398 438.5 67.8298 438.25C67.8298 438 67.7997 437.67 67.7797 437.26C67.7597 436.86 67.7197 436.35 67.6797 435.76C67.6497 435.34 67.6198 434.84 67.5798 434.27L74.5397 448.95L76.2397 449.93L76.2797 436",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9296 442.21L79.1597 441.19L79.1396 447.64C79.1396 448.51 79.2596 449.32 79.5196 450.09C79.7796 450.87 80.1397 451.57 80.6197 452.19C81.0897 452.8 81.6396 453.3 82.2896 453.67C82.8096 453.97 83.2797 454.13 83.7297 454.16C84.1797 454.18 84.5596 454.1 84.8896 453.88C85.0396 453.79 85.1696 453.67 85.2696 453.53V455.19L87.0296 456.21L87.0596 445.76L85.2896 444.74L85.2696 451.03C85.2696 451.4 85.2096 451.72 85.0996 451.97C84.9796 452.22 84.8196 452.4 84.6296 452.51C84.4296 452.62 84.1897 452.66 83.9097 452.63C83.6397 452.6 83.3296 452.49 82.9996 452.3C82.5496 452.04 82.1796 451.7 81.8596 451.28C81.5496 450.86 81.3097 450.38 81.1497 449.84C80.9897 449.3 80.8997 448.73 80.9097 448.12L80.9296 442.22",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9595 458.52C93.4195 458.21 92.9495 457.78 92.5395 457.23C92.1295 456.68 91.8095 456.07 91.5695 455.39C91.3395 454.72 91.2195 454.02 91.2195 453.34C91.2195 452.66 91.3395 452.13 91.5795 451.73C91.8195 451.33 92.1495 451.1 92.5595 451.03C92.9695 450.96 93.4495 451.08 93.9895 451.39C94.5295 451.7 94.9995 452.13 95.4095 452.67C95.8195 453.22 96.1495 453.82 96.3795 454.49C96.6095 455.16 96.7295 455.82 96.7295 456.51C96.7295 457.2 96.6095 457.75 96.3695 458.14C96.1295 458.54 95.8095 458.78 95.3895 458.85C94.9795 458.93 94.5095 458.81 93.9795 458.51M91.3295 443.92L89.5595 442.9L89.5195 457.57L91.2895 458.59V457.26C91.4995 457.67 91.7495 458.07 92.0495 458.48C92.3695 458.91 92.7095 459.3 93.0995 459.67C93.4895 460.04 93.8695 460.34 94.2595 460.56C95.0495 461.01 95.7495 461.19 96.3895 461.08C97.0195 460.97 97.5195 460.61 97.8795 459.99C98.2495 459.38 98.4295 458.54 98.4295 457.5C98.4295 456.46 98.2495 455.41 97.8895 454.39C97.5295 453.37 97.0295 452.43 96.3995 451.61C95.7795 450.79 95.0495 450.14 94.2395 449.67C93.8695 449.46 93.5095 449.32 93.1495 449.26C92.7895 449.2 92.4695 449.19 92.1595 449.24C91.8595 449.3 91.6095 449.41 91.4195 449.59C91.3795 449.62 91.3495 449.66 91.3195 449.69L91.3395 443.93",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.64 458.25C101.69 457.98 101.77 457.75 101.87 457.56C102.09 457.16 102.42 456.95 102.84 456.92C103.26 456.89 103.79 457.05 104.4 457.41C104.8 457.64 105.15 457.95 105.48 458.34C105.81 458.73 106.09 459.16 106.3 459.63C106.52 460.1 106.64 460.57 106.67 461.02V461.16L101.63 458.25M104.41 455.52C103.75 455.14 103.13 454.91 102.56 454.86C101.99 454.81 101.5 454.91 101.1 455.18C100.69 455.44 100.37 455.85 100.14 456.39C99.9095 456.93 99.7896 457.62 99.7896 458.44C99.7896 459.47 99.9895 460.51 100.39 461.53C100.8 462.57 101.36 463.51 102.07 464.38C102.78 465.25 103.6 465.95 104.53 466.49C104.96 466.74 105.39 466.91 105.83 467.03C106.28 467.16 106.69 467.2 107.09 467.19C107.49 467.19 107.82 467.1 108.09 466.94L107.21 464.97C106.76 465.16 106.35 465.24 105.96 465.19C105.57 465.13 105.15 464.98 104.71 464.73C104.08 464.37 103.52 463.9 103.04 463.33C102.56 462.76 102.19 462.13 101.93 461.44C101.73 460.92 101.61 460.39 101.57 459.84L108.46 463.82L108.48 462.96C108.49 462.23 108.4 461.5 108.2 460.77C108 460.04 107.72 459.34 107.35 458.68C106.98 458.01 106.54 457.4 106.04 456.86C105.54 456.31 104.99 455.87 104.41 455.53",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.27 463.19L115.5 462.17L115.47 472.62L117.24 473.64L117.27 463.19Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.379 457.78C116.009 457.57 115.719 457.52 115.509 457.63C115.299 457.75 115.189 458 115.189 458.38C115.189 458.79 115.299 459.17 115.499 459.51C115.699 459.85 115.999 460.13 116.369 460.35C116.739 460.57 117.019 460.61 117.229 460.49C117.439 460.38 117.549 460.12 117.549 459.74C117.549 459.33 117.449 458.95 117.239 458.61C117.039 458.26 116.739 457.98 116.369 457.77",
    fill: "#459AA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.43 476.47C124.85 476.13 124.31 475.7 123.82 475.17C123.34 474.63 122.92 474.04 122.55 473.38C122.19 472.73 121.92 472.02 121.72 471.29C121.53 470.56 121.44 469.84 121.44 469.09C121.44 468.34 121.54 467.72 121.73 467.22C121.93 466.72 122.21 466.34 122.56 466.1C122.93 465.86 123.35 465.75 123.83 465.78C124.32 465.81 124.86 466 125.44 466.33C126.02 466.66 126.56 467.1 127.04 467.63C127.53 468.17 127.94 468.76 128.3 469.42C128.65 470.08 128.93 470.78 129.13 471.51C129.33 472.24 129.43 472.97 129.42 473.7C129.41 474.43 129.31 475.05 129.11 475.55C128.91 476.05 128.63 476.43 128.28 476.68C127.92 476.93 127.5 477.04 127.01 477.01C126.52 476.98 125.99 476.79 125.41 476.46M125.47 464.24C124.62 463.75 123.84 463.48 123.13 463.42C122.41 463.37 121.79 463.5 121.26 463.84C120.73 464.18 120.31 464.7 120.02 465.4C119.72 466.1 119.57 466.97 119.57 468C119.57 469.03 119.71 470.07 120 471.12C120.29 472.16 120.7 473.15 121.23 474.1C121.76 475.05 122.38 475.91 123.1 476.68C123.81 477.45 124.59 478.08 125.44 478.57C126.29 479.06 127.07 479.33 127.78 479.38C128.5 479.43 129.12 479.29 129.65 478.94C130.19 478.6 130.6 478.08 130.9 477.38C131.2 476.68 131.34 475.81 131.34 474.79C131.34 473.77 131.21 472.74 130.91 471.71C130.62 470.67 130.21 469.67 129.68 468.71C129.15 467.75 128.53 466.89 127.81 466.12C127.1 465.35 126.32 464.72 125.47 464.24Z",
    fill: "#459AA4"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_934_180",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 269,
    y: 536,
    width: 139,
    height: 118
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M269.84 573.95L269.94 536.45L407.77 616.02L407.66 653.52L269.84 573.95Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_934_180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.8 562.261V557.701L281.95 558.931C282.69 559.361 283.24 559.871 283.6 560.491C283.96 561.091 284.14 561.751 284.14 562.451C284.14 563.151 283.95 563.601 283.58 563.811C283.21 564.011 282.67 563.911 281.94 563.491L279.8 562.261ZM281.95 557.121L277.87 554.761L277.83 568.341L279.77 569.461L279.79 564.021L281.26 564.871L283.96 571.881L286.28 573.221L283.37 565.901C284.3 566.171 284.99 566.081 285.44 565.621C285.89 565.151 286.11 564.471 286.12 563.591C286.12 562.831 285.97 562.061 285.66 561.271C285.35 560.481 284.88 559.721 284.25 558.991C283.63 558.271 282.85 557.641 281.95 557.121Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.1 568.68L295.17 567.56L295.15 573.56C295.15 574.52 294.93 575.14 294.51 575.41C294.08 575.68 293.51 575.6 292.78 575.19C292.05 574.78 291.48 574.18 291.06 573.43C290.64 572.67 290.43 571.81 290.43 570.85L290.45 564.85L288.53 563.74L288.51 570.07C288.51 571.05 288.67 571.98 289.01 572.86C289.34 573.74 289.8 574.53 290.38 575.22C290.97 575.91 291.62 576.47 292.36 576.89C292.92 577.21 293.44 577.39 293.93 577.42C294.42 577.45 294.83 577.33 295.13 577.07V578.34L297.06 579.46L297.09 568.69",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.4 581.921C303.91 581.641 303.46 581.241 303.02 580.691C302.59 580.151 302.24 579.521 301.97 578.821C301.7 578.111 301.58 577.391 301.58 576.651C301.58 575.911 301.71 575.341 301.98 574.941C302.25 574.541 302.6 574.341 303.04 574.301C303.48 574.261 303.94 574.391 304.43 574.671C304.92 574.951 305.4 575.371 305.83 575.901C306.26 576.431 306.61 577.041 306.88 577.741C307.15 578.441 307.28 579.151 307.28 579.891C307.28 580.631 307.14 581.211 306.87 581.621C306.6 582.021 306.25 582.251 305.81 582.291C305.37 582.331 304.91 582.211 304.4 581.921ZM301.6 567.581L299.66 566.461L299.62 580.921L301.56 582.041V580.481C301.89 581.171 302.33 581.851 302.9 582.501C303.46 583.151 304.1 583.681 304.83 584.101C305.65 584.571 306.39 584.761 307.07 584.681C307.75 584.591 308.28 584.231 308.67 583.601C309.06 582.971 309.26 582.121 309.26 581.031C309.26 579.941 309.07 578.881 308.69 577.811C308.31 576.751 307.78 575.801 307.12 574.961C306.45 574.121 305.7 573.461 304.87 572.981C304.17 572.571 303.53 572.371 302.95 572.371C302.38 572.371 301.93 572.541 301.6 572.881L301.62 567.581",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.119 577.93L311.179 576.81L311.149 587.58L313.089 588.7L313.119 577.93ZM312.179 573.1C311.829 572.9 311.529 572.87 311.299 573C311.069 573.13 310.939 573.4 310.939 573.81C310.939 574.22 311.059 574.63 311.289 575.04C311.519 575.45 311.819 575.76 312.169 575.96C312.519 576.16 312.799 576.19 313.039 576.05C313.279 575.91 313.399 575.64 313.399 575.24C313.399 574.84 313.279 574.43 313.049 574.02C312.819 573.61 312.529 573.31 312.179 573.11",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.71 583.471L320.69 582.301L318.77 584.851L316.75 580.031L314.56 578.761L317.57 585.981L314.53 589.531L316.56 590.701L318.47 588.151L320.48 592.971L322.68 594.241L319.67 587.041L322.71 583.471Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.979 586.98C332.879 586.35 331.869 586.05 330.939 586.12C330.009 586.18 329.279 586.58 328.739 587.32C328.199 588.07 327.919 589.1 327.919 590.42C327.919 591.74 328.189 593.1 328.719 594.47C329.249 595.84 329.979 597.08 330.899 598.2C331.819 599.32 332.829 600.2 333.939 600.85C335.199 601.58 336.319 601.87 337.299 601.73C338.279 601.59 338.999 601 339.439 599.95L337.109 598.6C336.809 599.14 336.379 599.43 335.829 599.47C335.279 599.51 334.649 599.32 333.939 598.91C333.159 598.46 332.459 597.85 331.849 597.08C331.239 596.32 330.759 595.46 330.419 594.5C330.079 593.55 329.909 592.57 329.909 591.56C329.909 590.55 330.089 589.78 330.429 589.22C330.779 588.66 331.259 588.36 331.869 588.31C332.479 588.26 333.189 588.46 333.969 588.91C334.689 589.32 335.309 589.86 335.859 590.53C336.399 591.2 336.829 591.98 337.129 592.86L339.459 594.21C339.019 592.66 338.319 591.24 337.339 589.96C336.359 588.68 335.239 587.68 333.979 586.96",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.76 605.801C344.98 605.351 344.33 604.661 343.82 603.731C343.3 602.801 343.05 601.761 343.06 600.601C343.06 599.821 343.19 599.231 343.44 598.831C343.69 598.441 344.03 598.221 344.45 598.191C344.88 598.171 345.34 598.291 345.84 598.581C346.34 598.871 346.8 599.281 347.24 599.801C347.67 600.321 348.01 600.931 348.27 601.621C348.53 602.311 348.66 603.051 348.65 603.831C348.65 604.611 348.51 605.201 348.24 605.581C347.97 605.981 347.61 606.181 347.18 606.201C346.75 606.221 346.27 606.091 345.77 605.801M345.87 596.671C344.97 596.151 344.16 595.911 343.44 595.951C342.71 595.991 342.13 596.311 341.72 596.921C341.3 597.521 341.08 598.371 341.08 599.471C341.08 600.571 341.28 601.661 341.68 602.741C342.09 603.811 342.65 604.791 343.36 605.661C344.07 606.531 344.87 607.231 345.75 607.741C346.63 608.251 347.47 608.501 348.21 608.461C348.95 608.421 349.54 608.111 349.98 607.521C350.41 606.921 350.63 606.071 350.63 604.981C350.63 603.891 350.43 602.791 350.01 601.701C349.6 600.611 349.02 599.631 348.3 598.751C347.58 597.881 346.77 597.181 345.88 596.671",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.92 607.081C363.22 606.681 362.58 606.501 361.98 606.541C361.38 606.571 360.94 606.841 360.65 607.331C360.33 606.451 359.88 605.671 359.29 604.961C358.7 604.251 358.03 603.681 357.29 603.251C356.73 602.931 356.21 602.751 355.72 602.721C355.23 602.691 354.82 602.801 354.51 603.061V601.831L352.57 600.711L352.54 611.481L354.48 612.601L354.5 606.581C354.5 605.621 354.72 605.001 355.14 604.731C355.56 604.461 356.14 604.531 356.87 604.951C357.6 605.371 358.17 605.961 358.59 606.711C359.01 607.461 359.21 608.331 359.21 609.291L359.19 615.311L361.11 616.421L361.13 610.401C361.13 609.441 361.35 608.821 361.77 608.551C362.2 608.281 362.77 608.361 363.5 608.781C364.23 609.201 364.8 609.781 365.22 610.541C365.63 611.291 365.84 612.161 365.84 613.121L365.82 619.141L367.74 620.251L367.76 613.901C367.76 612.921 367.6 611.991 367.27 611.111C366.93 610.221 366.48 609.441 365.9 608.751C365.31 608.061 364.66 607.501 363.92 607.081Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.989 622.681C374.499 622.401 374.039 621.991 373.609 621.451C373.169 620.901 372.819 620.281 372.559 619.581C372.289 618.871 372.159 618.141 372.159 617.401C372.159 616.661 372.299 616.091 372.569 615.701C372.829 615.301 373.189 615.091 373.629 615.061C374.069 615.021 374.529 615.151 375.019 615.431C375.509 615.711 375.979 616.131 376.419 616.661C376.849 617.191 377.199 617.801 377.469 618.501C377.739 619.201 377.859 619.911 377.859 620.651C377.859 621.391 377.729 621.971 377.459 622.381C377.189 622.781 376.839 623.011 376.399 623.051C375.959 623.091 375.489 622.971 374.989 622.681ZM375.449 613.741C374.729 613.331 374.089 613.121 373.529 613.141C372.959 613.161 372.509 613.321 372.179 613.621V612.041L370.239 610.921L370.189 626.811L372.129 627.931L372.149 621.251C372.499 621.941 372.949 622.621 373.509 623.281C374.059 623.931 374.699 624.471 375.419 624.881C376.229 625.351 376.979 625.541 377.659 625.461C378.329 625.371 378.859 625.011 379.259 624.381C379.649 623.751 379.839 622.891 379.839 621.811C379.839 620.731 379.649 619.661 379.269 618.611C378.879 617.551 378.349 616.601 377.689 615.751C377.009 614.901 376.269 614.231 375.459 613.761",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.25 622.461L388.32 621.341L388.3 627.341C388.3 628.301 388.08 628.92 387.66 629.19C387.24 629.46 386.66 629.38 385.93 628.97C385.2 628.56 384.63 627.961 384.21 627.211C383.79 626.451 383.58 625.59 383.58 624.63L383.6 618.63L381.68 617.521L381.66 623.85C381.66 624.83 381.82 625.761 382.16 626.641C382.49 627.521 382.95 628.31 383.53 629C384.12 629.69 384.77 630.25 385.51 630.67C386.07 630.99 386.59 631.171 387.08 631.201C387.57 631.231 387.98 631.11 388.28 630.85V632.12L390.21 633.24L390.24 622.47",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.08 622.57L393.13 621.44V624.12L392.02 623.48V625.3L393.12 625.94L393.1 631.9C393.1 632.96 393.32 633.85 393.79 634.59C394.25 635.33 394.92 635.95 395.79 636.45L397.32 637.33V635.47L396.14 634.78C395.74 634.55 395.46 634.3 395.3 634.03C395.13 633.76 395.05 633.42 395.05 633.01L395.07 627.05L397.35 628.37V626.55L395.08 625.23V622.55",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.5 632.8C400.59 632.02 400.87 631.52 401.35 631.31C401.82 631.09 402.4 631.18 403.07 631.57C403.8 631.99 404.42 632.6 404.92 633.38C405.42 634.17 405.67 634.97 405.68 635.8L400.5 632.81M403.16 629.74C402.24 629.21 401.43 628.97 400.72 629.01C400.01 629.06 399.46 629.39 399.07 630C398.67 630.62 398.48 631.48 398.47 632.59C398.46 633.7 398.66 634.78 399.06 635.86C399.46 636.93 400.01 637.9 400.72 638.77C401.43 639.64 402.23 640.34 403.12 640.86C404.22 641.49 405.14 641.71 405.89 641.51C406.63 641.31 407.15 640.79 407.44 639.96L405.35 638.75C404.92 639.51 404.18 639.58 403.14 638.98C402.41 638.56 401.81 637.95 401.3 637.14C400.8 636.33 400.53 635.48 400.48 634.58L407.64 638.71C407.69 638.41 407.71 638.06 407.71 637.66C407.71 636.62 407.52 635.58 407.14 634.56C406.76 633.54 406.22 632.61 405.53 631.76C404.84 630.91 404.06 630.24 403.17 629.73",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.72 537.471C270.74 536.901 269.94 537.351 269.94 538.481L269.85 571.901C269.85 573.021 270.64 574.401 271.62 574.961C272.6 575.521 273.4 575.071 273.4 573.951L273.49 540.531C273.49 539.401 272.7 538.031 271.72 537.471Z",
    fill: "#459AA4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_934_180"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 588.57,
    height: 839.89,
    fill: "white",
    transform: "translate(0.179688)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubixCompute);
export default __webpack_public_path__ + "static/media/RubixCompute.b7ad04084d8ab58588520ec267d80011.svg";
export { ForwardRef as ReactComponent };